/**
 * Transform the date to a UTC Date formatted with Year / Month / Day
 * */
export const getUTCDate = (date: Date) => {
    return new Date(Date.UTC(date.getUTCFullYear(), date.getUTCMonth(), date.getUTCDate()));
};
